// extracted by mini-css-extract-plugin
export default {"container":"ProductPersonalDetails_container__finB1","boxLess":"ProductPersonalDetails_boxLess__gCdz8"};